import React, { Fragment, useState } from 'react'

import useWindowSize from '../components/WindowSize';

import Footer from '../components/Footer';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
    const [width] = useWindowSize();

    return ( 
        <Fragment>
            <div className="page private-policy-page">
                  <div className="private-policy-text-content">
                    
                    <div className='private-policy-text-content-overlay'>
                
                      <h1>FactSense Privacy Policy</h1>
                       
                      <div className='general'>
                      This privacy policy applies to the FactSense app (hereby referred to as "Application") for 
      mobile devices that was created by Pui Ling Hon (hereby referred to as "Service Provider") as a 
      Commercial service. This service is intended for use "AS IS".
                      </div>
                        <br />
                      <div className='general'>
                      This page is used to inform visitors regarding my
                        policies with the collection, use, and disclosure of Personal
                        Information if anyone decided to use my Service.
                      </div>
                      <br/>
                      <div className='general'>
                      If you choose to use my Service, then you agree to
                        the collection and use of information in relation to this
                        policy. The Personal Information that I collect is
                        used for providing and improving the Service. I will not use or share your information with
                        anyone except as described in this Privacy Policy.
                      </div>
                      <br/>
                      <div className='general'>
                      The terms used in this Privacy Policy have the same meanings
                        as in our Terms and Conditions, which are accessible at
                        FactSense unless otherwise defined in this Privacy Policy.
                      </div>
                      <br/>
                      <div className='general'>
                          <h2>Information Collection and Use</h2>
                          <br/>
                          <div>
                          For a better experience, while using our Service, I
                        may require you to provide us with certain personally
                        identifiable information. An email and a password you created for accessing some functions of the app.  
                        If you use the app's Google Sign-In feature, the app will collect your email address and name.
                        The information that
                        I request will be retained on your device and is not collected by me in any way.
                          </div>
                          
                      </div>
                      <br/>
                      <div className='general'>The app does use third-party services that may collect
                          information used to identify you.</div>
                          <br/>
                          <div> I want to inform you that whenever you
                        use my Service, in a case of an error in the app
                        I collect data and information (through third-party
                        products) on your phone called Log Data. This Log Data may
                        include information such as your device Internet Protocol
                        (“IP”) address, device name, operating system version, the
                        configuration of the app when utilizing my Service,
                        the time and date of your use of the Service, and other
                        statistics.</div>
                        <br/>
                        <div className='general'><h2>Cookies</h2>
                        Cookies are files with a small amount of data that are
                        commonly used as anonymous unique identifiers. These are sent
                        to your browser from the websites that you visit and are
                        stored on your device's internal memory.
                        </div>
                        <br/>
                        <div className='general'>This Service does not use these “cookies” explicitly. However,
                        the app may use third-party code and libraries that use
                        “cookies” to collect information and improve their services.
                        You have the option to either accept or refuse these cookies
                        and know when a cookie is being sent to your device. If you
                        choose to refuse our cookies, you may not be able to use some
                        portions of this Service.</div>
                        <br/>
                        <div><h2>Service Providers</h2>
                        <br/>
                        I may employ third-party companies and
                        individuals to facilitate our Service.
                        </div>
                        <br/>
                        <div className='general'>
                          <div>
                        I want to inform users of this Service
                        that these third parties have access to their Personal
                        Information. The reason is to perform the tasks assigned to
                        them on our behalf. However, they are obligated not to
                        disclose or use the information for any other purpose.
                        </div>
                        <br/>
                        <div>
                        For a better experience, while using the Application, the Service Provider may require you to provide us with certain personally identifiable information, 
                including but not limited to email, name. The information that the Service Provider request will be retained by them and used as described in this privacy 
                policy.
                </div>
                        </div>
                      <div className='general'><h2>Data Retention Policy</h2>
                      <p>The Service Provider will retain User Provided data for as long as you use the Application and for a reasonable time thereafter. 
                      If you'd like them to delete User Provided Data that you have provided via the Application, please contact them at jessie-apps-store@gmail.com and they will respond in a reasonable time.
                       Or you can visit the app's website, jess-apps.com/checkdiy, data privacy section to submit the request to delete the user account and/or data associated.</p><br/>
                      
                      </div>

                        <br/>
                        <div className='general'><h2>Security</h2>
                        <br/>
                        I value your trust in providing us your
                        Personal Information, thus we are striving to use commercially
                        acceptable means of protecting it. But remember that no method
                        of transmission over the internet, or method of electronic
                        storage is 100% secure and reliable, and I cannot
                        guarantee its absolute security.
                        </div>
                        <br/>
                        <div className='general'><h2>Links to Other Sites</h2>
                        <br/>
                        This Service may contain links to other sites. If you click on
                        a third-party link, you will be directed to that site. Note
                        that these external sites are not operated by me.
                        Therefore, I strongly advise you to review the
                        Privacy Policy of these websites. I have
                        no control over and assume no responsibility for the content,
                        privacy policies, or practices of any third-party sites or
                        services.</div>
                        <br/>
                        <div className='general'><h2>Children’s Privacy</h2>
                        <br/>
                        These Services do not address anyone under the age of 13.
                          I do not knowingly collect personally
                          identifiable information from children under 13 years of age. In the case
                          I discover that a child under 13 has provided
                          me with personal information, I immediately
                          delete this from our servers. If you are a parent or guardian
                          and you are aware that your child has provided us with
                          personal information, please contact me so that
                          I will be able to do the necessary actions.
                        </div>
                        <br/>
                        <div className='general'><h2>Changes to This Privacy Policy</h2>
                        <br/>
                        I may update our Privacy Policy from
                        time to time. Thus, you are advised to review this page
                        periodically for any changes. I will
                        notify you of any changes by posting the new Privacy Policy on
                        this page.
                        </div>
                        <br/>
                        <div className='general last'><h2>This policy is effective as of 2025-04-08</h2>
                        <br/>
                        If you have any questions or suggestions about my
                        Privacy Policy, do not hesitate to contact me at jessie.apps.store@gmail.com.
                      </div>
                      </div>
                      </div>
            </div>
            <Footer />
        </Fragment>
    )
}

export default PrivacyPolicy;

